import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ApiService } from '../lib/api.service';
import { ProgressService } from '../lib/progress.service';
import { firstValueFrom } from 'rxjs';

export const eventSlugExistsGuard: CanActivateFn = async (route, state) => {
  const eventSlug = route.paramMap.get('eventSlug') || '';
  const router = inject(Router);
  const apiService = inject(ApiService);
  const progressService = inject(ProgressService);

  try {
    // Load bookable events from API
    const bookableEvents = await firstValueFrom(apiService.fetchBookableEvents());

    // Find event by slug
    const existingEvent = bookableEvents.find(
      (event) => event.slug === eventSlug,
    );

    const result = !!eventSlug && !!existingEvent;

    if (!result) {
      console.warn('[Guard] Event slug does not exist:', eventSlug);
      router.navigateByUrl('/');
      return false;
    } else {
      const festival = progressService.selectedFestival();
      if (!festival || festival.id !== existingEvent?.apiId) {
        progressService.festivalSelected(existingEvent?.apiId);
      }
      return true;
    }
  } catch (error) {
    router.navigateByUrl('/');
    return false;
  }
};
